import React from 'react';
import { styled } from 'linaria/react';
import { Link } from 'react-router-dom';
import { Intl } from '@jetshop/intl';
import { ReactComponent as MobelmastarnasLogos } from '../../svg/Logo.svg';
import { cx, css } from 'linaria';
import { theme } from '../Theme';

const SvgWrapper = styled('div')`
  width: ${(props) => props.size}px;
  margin-top: 5px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

const logoWrapperStyle = css`
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  /* margin-bottom: -18px; */
  padding-bottom: 4px;

  ${theme.below.lg} {
    margin-bottom: 0;
    align-items: center;
  }
`;

const Logo = ({ size }) => {
  return (
    <div className={cx('logo-wrapper', logoWrapperStyle)}>
      <Intl>
        {(t) => (
          <Link to="/" aria-label={t('Möbelmästarnas startsida')}>
            <SvgWrapper size={size}>
              <MobelmastarnasLogos />
            </SvgWrapper>
          </Link>
        )}
      </Intl>
    </div>
  );
};

export default Logo;
